import { Audience as AudienceDataSchema } from '@schema';
import { z } from 'zod';

export const ChartAudienceSchema = z.object({
  color: z.string(),
  id: z.string(),
  title: z.string()
});

export const ChartDataSchema = z.object({
  name: z.string(),
  value: z.number(),
  suffix: z.string().optional(),
  isOrigin: z.boolean().optional(),
  audience: ChartAudienceSchema.optional(),
  percentage: z.number().optional(),
  index: z.number().optional(),
  size: z.number().optional()
});

export const GridPropsSchema = z.object({
  layout: z.enum(['vertical', 'horizontal']).default('vertical'),
  columns: z.enum(['1', '2', '3', '4']).default('1'),
  gap: z.enum(['sm', 'md', 'lg']).default('md')
});

export const HorizontalStackedBarChartPropsSchema = z.object({
  title: z.string().optional(),
  body: z.string().optional(),
  data: z.array(ChartDataSchema),
  colors: z.array(z.string()).optional()
});

export const AudienceOverlapStatSchema = z.object({
  value: z.string(),
  label: z.string()
});

export const AudienceOverlapPropsSchema = z.object({
  title: z.string().optional(),
  audienceData: z.array(AudienceDataSchema).length(3),
  stats: z.array(AudienceOverlapStatSchema).min(1).optional()
});

export const InsightCardPropsSchema = z.object({
  title: z.string().optional(),
  body: z.string().optional(),
  value: z.string(),
  description: z.string().optional()
});

export const RadioStatCardPropsSchema = z.object({
  percentage: z.number().min(0).max(100),
  index: z.string(),
  label: z.string()
});

export const QuoteCardPropsSchema = z.object({
  text: z.string()
});

export const OutputCardPropsSchema = z.object({
  title: z.string(),
  intro: z.string(),
  items: z.array(z.string()).min(1)
});

export const LineBarChartRowSchema = z.object({
  label: z.string(),
  percentage: z.number().min(0).max(100),
  index: z.string()
});

export const LineBarChartCardPropsSchema = z.object({
  title: z.string(),
  rows: z.array(LineBarChartRowSchema).min(1)
});

export const SectionTitlePropsSchema = z.object({
  text: z.string()
});
